export const PP_BADGES = ["Insured", "Background-Checked", "Woman-Owned", "9 Years of Experience", "English & Português"];

export const PP_SERVICES = [
  ["Securing & Lock Changes", "Initial secure, knob locks, deadbolts, lockboxes, padlocks & hasps, slider and window locks, re-secures."],
  ["Boarding & Clear Boarding", "Bolt boarding for broken windows and doors, security doors, reglazing and security film."],
  ["Winterization & De-Winterization", "Dry, wet/steam and radiant systems, pressure tests, full de-winterization and system reactivation."],
  ["Trash-Outs & Debris Removal", "Interior and exterior debris, personal property set-aside per client and legal guidelines, hazardous item documentation."],
  ["Cleaning & Sales Cleans", "Initial and refresh maid services, REO sales cleans and broom-clean condition."],
  ["Lawn, Snow & Exterior", "Initial and recurring lawn care, tree trimming, snow removal, curb appeal."],
  ["Pool Services", "Pool securing, draining and maintenance per HUD guidelines."],
  ["Vehicle & Boat Removal", "Documented removal with tow receipts."],
  ["Eviction Services", "Complete set-outs coordinated with the sheriff/constable, with lock change on site."],
  ["Sump Pump & Water Issues", "Sump pump replacement and standing-water documentation."],
  ["Field Inspections", "Occupancy, PCR, interior/exterior, drive-by, FHA/HUD/REO, QC, insurance loss and draw inspections.", "/inspections#occupancy-verification"],
];

export const PP_COUNTIES = ["Northumberland", "Montour", "Columbia", "Snyder", "Union", "Schuylkill", "Luzerne", "Dauphin", "Lycoming", "Carbon"];

export const PP_CAPABILITY = [
  `Coverage area: ${PP_COUNTIES.join(", ")} counties, PA — from our Coal Township office; our Doylestown office covers Bucks and Montgomery.`,
  "Our own crew of 4 — we self-perform securing, winterizations, trash-outs, cleans and evictions.",
  "9 years of property preservation and mortgage field services experience in Pennsylvania.",
  "General liability insured ($1M/$2M) — certificate of insurance available on request.",
  "Background-checked through Aspen Grove / ShieldHub.",
  "We work in your systems: Property Preservation Wizard (PPW) and InspectorADE.",
  "Timestamped photo documentation on every order: before, during and after.",
  "First-time-vacant results reported within 24 hours.",
];

export const PP_FLOW = [
  "Order received in your portal or by email",
  "Property documented on arrival",
  "Work executed to client guidelines and HUD standards",
  "Photo report uploaded the same day",
  "Invoice with completion documentation",
];

export const PP_FORM_SERVICES = ["Securing", "Winterization", "Trash-Out", "Lawn & Snow", "Eviction", "Pool", "Inspections", "Other"];
